"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const usePref_1 = __importDefault(require("./usePref"));
const MAX_ITEMS = 10;
// recent items are scoped to userId, since you can potentially switch users
// (either via logout/login, or "log in as")
exports.default = (userId) => {
    const [recentItems, setRecentItems] = usePref_1.default('recentItems', {});
    const ref = react_1.useRef();
    ref.current = { userId, recentItems };
    /**
     * Add a recent item to the front of the list
     *
     * @param {Object} item the item to add
     * @param {string} item.name descriptive name for the item
     * @param {string} item.path relative URL path to the item
     * @param {string} item.type project | shared-project | termbase | transmemory
     */
    const addRecentItem = react_1.useCallback(item => {
        const { userId, recentItems } = ref.current;
        const allNewItems = { ...recentItems };
        const newItems = (allNewItems[userId] || [])
            .filter(({ path }) => path !== item.path) // remove it if it's later in the list
            .slice(0, MAX_ITEMS - 1);
        allNewItems[userId] = [item, ...newItems];
        setRecentItems(allNewItems);
    }, [ref, setRecentItems]);
    return [recentItems[userId] || [], addRecentItem];
};
//# sourceMappingURL=useRecentItems.js.map